<script>
import {addNote, cancelOrder, getAllPublicData, getOrderDetail, getOrderList, refundHandle} from "../../api/order"
import orderDetails from "../../components/order-detail/index.vue";
import {searchColumn} from "@/view/order/searchColumn";

export default {
  components: {
    orderDetails,
  },
  data() {
    return {
      searchColumn,
      total_num: 0,
      orderList: [],
      order_page: 1,
      order_limit: 10,
      detialDialog: false,
      info: '',
      show_tag: "first",//用来控制弹框内的标签显示
      order_loading:false,
      refundDialog:false,
      noteDialog:false,
      order_note:'',
      note_modal:false,
      refund_modal:false,
      cancel_modal:false,
      cancelDialog:false,
      choose_order:{
        refund_info:{},
        pay_info:{}
      },
      refund_form:{
        amtRefund:"",
        noteRefund:""
      },
      refund_rules:{
        amtRefund: [
          { required: true, message: 'The refund amount cannot exceed the actual amount received for the order. / The refund amount must be greater than 0.', trigger: 'blur' }
        ],
      },
      itemTypeImgList:[
        {img:require('../../assets/order/1.png'),id:1},
        {img:require('../../assets/order/2.png'),id:2},
        {img:require('../../assets/order/3.png'),id:3},
        {img:require('../../assets/order/4.png'),id:4},
        {img:require('../../assets/order/5.png'),id:5},
        {img:require('../../assets/order/6.png'),id:6},
        {img:require('../../assets/order/7.png'),id:7},
        {img:require('../../assets/order/8.png'),id:8},
      ],
      searchObj:{},
      refund_loading:false,
      choose_oreer_refund:"",//取消订单金额
    }
  },
  created() {
    const { userName } = this.$route.query
    if (userName){
      this.searchObj.user_id = userName
      this.searchObj.status = 9
    }
    this.getPublicDataHnadle()
    this.getList(this.searchObj)
  },
  methods: {
    refundSubmitHandle(){
      this.$refs.refund_form_rules.validate((valid) => {
        if (valid) {
          if (this.refund_loading){
            this.$message({
              type: 'warning',
              message:"Please do not submit again"
            })
          }else{
            this.refund_loading = true
            refundHandle({
              id:this.choose_order.id,
              refund_amount:this.refund_form.amtRefund,
              note:this.refund_form.noteRefund,
            }).then(res=>{
              this.refund_loading = false
              if (res.code == 200){
                this.$refs.taskDetialRef.getOrderDetialHandle()
                this.getList()
                this.refundDialog = false
                this.$message({
                  type:"success",
                  message:res.msg
                })
              } else {
                this.$message({
                  type:'error',
                  message:res.msg
                })
              }
            })
          }
        }
      })

    },
    closeRefundHandle(){
      this.refund_form.amtRefund = ''
      this.refund_form.noteRefund = ''
      this.refundDialog = false
      this.$refs.refund_form_rules.clearValidate()
    },
    cancelHandle(){
      cancelOrder({
        id:this.choose_order.id,
        reason:''
      }).then(res=>{
          if (res.code == 200){
            this.cancelDialog = false;
            this.detialDialog = false
            this.getList();
            this.$message({
              type:"success",
              message:res.msg
            })
          }else {
            this.$message({
              type:"error",
              message:res.msg
            })
          }
      })
    },
    noteAddHnandle(a){
      this.choose_order = a
      this.noteDialog = true;
      this.note_modal = true;
    },
    cancelOrderHandle(a){
      this.choose_order = a
      this.choose_oreer_refund = a.fee
      this.cancel_modal = true;
      this.cancelDialog = true;
    },
    showRefundHnalde(a){
      getOrderDetail({
        id:a.id
      }).then(res => {
        this.detialLoading = false
        if (res.code == 200){
          this.choose_order =  res.data
        }
      })
      this.$forceUpdate()
      this.refund_modal = true;
      this.refundDialog = true;
    },
    submitNoteHandle(){
      if (this.order_note == ''){
        this.$message({
          type:"warning",
          message:'Some information missing'
        })
        return
      }
      addNote({
        id:this.choose_order.id,
        note:this.order_note
      }).then(res=>{
        if (res.code == 200){
          this.noteDialog = false
          this.order_note = ''
          this.getList()
          this.$message({
            type:"success",
            message:res.msg
          })
        }else {
          this.$message({
            type:"error",
            message:res.msg
          })
        }
      })

    },
    getStatusClass(item) {
      if (item.status < 7) return 'same';
      if (item.status === 7) return 'canceled';
      if(item.status === 8) return 'same';
      if (item.status === 9) return item.delivery_status === 1 ? 'delivered' : 'failed';
      return '';
    },
    openOrderDialogHandle(e){
      if (e.type == 'note'){
        this.note_modal = false;
        this.noteDialog = true;
      }else if (e.type == 'cancel'){
        this.cancel_modal = false
       this.cancelDialog = true
      }else{
        this.choose_order = e
        this.refund_modal = false;
        this.refundDialog = true;
      }
    },
    getPublicDataHnadle(){
      getAllPublicData().then(res=>{
          if (res.code === 200) {
            searchColumn.forEach(v=>{
              if (v.prop == "from_city" || v.prop == "to_city"){
                v.options = res.data.zone_list
              }
              if (v.prop == 'parcel_type'){
                v.options = res.data.parcel_types
              }
            })
          }
      })
    },
    searchHandler(params) {
      this.searchObj = params
      this.order_page = 1
      this.getList(params)
    },
    clearHandle(params){
      const { userName } = this.$route.query
      if (userName){
        this.$router.replace({ query: {} });
      }
      this.order_page = 1
      this.getList(params)
    },
    getList(params = {}) {
      console.log(params,'ddd')
      this.order_loading = true
      getOrderList({
        page: this.order_page,
        limit: this.order_limit,
        ...params
      }).then(res => {
        this.order_loading = false
        if (res.code == 200) {
          this.total_num = Number(res.data.total);
          this.orderList = res.data.list
          this.orderList.map((parcel) => {
            const matchingItem = this.itemTypeImgList.find((item) => item.id === parcel.parcel_type)
            if (matchingItem) {
              parcel.img = matchingItem.img
            }
          });

        }
      })
    },
    handleOrderCurrentChange(val) {
      this.order_page = val
      this.getList(this.searchObj);
    },
    showOrderDetialHnadle(i) {
      this.info = i
      this.choose_order = i
      this.choose_oreer_refund = i.fee
      this.detialDialog = true
      setTimeout(() => {
        this.$refs.taskDetialRef.getOrderDetialHandle()
      },100)
    },

    async handleBeforeClose() {
      console.log('这里进来了吗')
      // 获取 orderDetails 组件的实例
      const orderDetailsRef = this.$refs.taskDetialRef;
      // 如果 orderDetails 组件中有内层弹框，调用其关闭方法
        await orderDetailsRef.refundDetialDialogHandle(); // 假设 closeInnerDialog 是异步的
      // 关闭外层弹框
    },
  }
}
</script>

<template>
  <div class="main_order_box">
    <ra-search-box
        :search-fields="searchColumn"
        @search="searchHandler"
        @clear="clearHandle"
    ></ra-search-box>
    <div class="total_order_box">
      Total orders: {{ total_num }}
    </div>
    <div class="table_title">
      <div class="one">Basic info</div>
      <div class="two">Recipient</div>
      <div class="three">Fee</div>
      <div class="four">Status</div>
      <div class="five">Operation</div>
    </div>
    <div class="main_table"  v-loading="order_loading">
      <div v-if="orderList.length > 0">
        <div v-for="(i,v) in orderList" :key="v">
          <div>
            <div class="top">
              <div class="innerLeft">
                <div>
                  <span class="titleColor">Tracking#:</span> {{ i.order_no }}
                </div>
              </div>
              <div><span class="titleColor">Created:</span> {{ i.created_at }}</div>
            </div>
            <div class="btom"  :style="{borderRadius:i.note ? 0 :''}">
              <div class="one all">
                <div class="left p-3.5 pb-3.5">
                  <img :src="i.img" class="mt-0" alt="">
                </div>
                <div class="rights">
                  <div class="innerTop">
                    <div class="localBox">
                      <img src="../../assets/order/sender@2x.png" alt="">
                    </div>
                    <div>
                      {{ i.sender_address }}
                    </div>
                    <div class="pathway_img">
                      <img src="../../assets/order/pathway.png" alt="">
                    </div>
                    <div class="localBox">
                      <img src="../../assets/order/recipient@2x.png" alt="">
                    </div>
                    <div>
                      {{ i.receiver_address }}
                    </div>
                  </div>
                  <div class="innerBtom">Parcel Size: {{ i.parcel_size_text }}</div>
                </div>
              </div>
              <div class="two all"><span>{{ i.receiver_name }}</span></div>
              <div class="three all">
                <div>
                <div>{{ i.fee }}</div>
                  <div class="middle_line"></div>
                  <div>OTTPAY</div>
                </div>

              </div>
              <div class="four all">
                <div>
                  <div  :class="getStatusClass(i)">{{i.status_text}}</div>
                  <div style="cursor: pointer" @click="showOrderDetialHnadle(i)">Order detail</div>
                </div>
              </div>
              <div class="five all">

                <span style="cursor: pointer"  v-if="i.status != 7" @click="showRefundHnalde(i)">
              <img src="../../assets/order/return_t.png" alt="">
              </span>
                <span v-else>
              <img src="../../assets/order/return@2x.png" alt="">
              </span>

                <span style="cursor: pointer" v-if="i.status < 4" @click="cancelOrderHandle(i)">
              <img src="../../assets/order/cancel_order_dis.png" alt="">
              </span>
                <span v-else>
              <img src="../../assets/order/cancel_order.png" alt="">
              </span>
                <span style="cursor: pointer" @click="noteAddHnandle(i)">
              <img src="../../assets/order/edit@2x.png" alt="">
              </span>
              </div>
            </div>
          </div>
          <div v-if="i.note" class="note_box h-8 mb-4 rounded-b-2xl text-left leading-8 px-6">
            {{i.note}}
          </div>
        </div>
      </div>
      <table-empty v-else></table-empty>
      <ra-pagination
          :current-page="order_page"
          :list-length="orderList.length"
          :total="total_num"
          @pageChange="handleOrderCurrentChange"
      ></ra-pagination>
    </div>
    <!--  详情dialog-->
    <el-dialog
        :close-on-click-modal="false"
        custom-class="right"
        title="Order Details"
        :visible.sync="detialDialog"
        @close="handleBeforeClose"
        width="600px">
      <orderDetails :info="info" ref="taskDetialRef" @openOrderDialogHandle="openOrderDialogHandle" :show_tag="show_tag"></orderDetails>
    </el-dialog>
<!--    退款-->
    <el-dialog
      :modal="refund_modal"
      style="padding-top: 0"
      title="Refund"
      :visible.sync="refundDialog"
      @close="closeRefundHandle"
      width="35%">
      <div v-loading="refund_loading">
        <div class="my-4">Amount: {{choose_order.pay_info?.original_amount_paid}} (HST incl.)</div>
        <div class="my-4">Amt. Paid: {{choose_order.pay_info?.actual_amount_paid}} </div>
        <div class="mt-4">Refunded Amt.: {{choose_order.pay_info?.total_refunded}}</div>
        <div>
          <el-form :model="refund_form" :rules="refund_rules" ref="refund_form_rules" status-icon>
            <el-form-item label="Amt. for refund:" prop="amtRefund">
              <el-input v-model="refund_form.amtRefund" type="text" placeholder="input the amount for refund"></el-input>
            </el-form-item>
            <el-form-item label="Note for refund">
              <el-input v-model="refund_form.noteRefund" type="textarea" resize="none" maxlength="200"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button plain  style="width: 80px;padding: 0"  @click="closeRefundHandle">Cancel</el-button>
        <el-button type="success" round style="width: 80px;padding: 0" @click="refundSubmitHandle">Submit</el-button>
      </span>
    </el-dialog>
<!--    添加note-->
    <el-dialog
      :modal="note_modal"
      style="padding-top: 0"
      title="Note this order"
      :visible.sync="noteDialog"
      width="35%">
      <div class="mt-4">
        <el-input type="textarea" v-model="order_note" placeholder="" resize="none"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button plain  style="width: 80px;padding: 0"  @click="noteDialog = false;order_note = ''">Cancel</el-button>
        <el-button type="success" round style="width: 80px;padding: 0"  @click="submitNoteHandle">Submit</el-button>
      </span>
    </el-dialog>
<!--    取消订单-->
    <el-dialog
      :modal="cancel_modal"
      style="padding-top: 0"
      title="Cancel this order"
      :visible.sync="cancelDialog"
      width="35%">
      <div class="mt-6">
        Are you sure you want to cancel your order? The amount of {{choose_oreer_refund}} will be refunded to your original payment method within 2-5 business days.
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button plain style="width: 80px;padding: 0"  @click="cancelDialog = false">No</el-button>
        <el-button type="success" round style="width: 80px;padding: 0"  @click="cancelHandle">Yes</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style scoped lang="less">
@import "order";
</style>
